import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/service/[id]/ServiceDetailClient.tsx");
